export default {
    methods: {
        getApplicationPath(){
            return window.location.origin.concat(window.location.pathname)
        }
    }
};